import React, {useEffect, useRef, useState} from 'react';
import {Modal} from "../../../../components/modal/modal.jsx";
import {useQuery} from "@tanstack/react-query";
import formBuilderService from "../../../../services/web/form-builder-service.js";
import FormFill from "./components/form-fill.jsx";
import FormList from "./components/form-list.jsx";
import FormSubmissions from "./components/form-submissions.jsx";
import Button from "../../../../components/button/button.jsx";

const FormBuilderModal = ({module, externalId, object, open, setOpen, setIsLoading, canCreateNewForms = true}) => {
    const [mode, setMode] = useState("list")
    const [templateId, setTemplateId] = useState(null)

    useEffect(() => {
        if (!open) setMode("list")
    }, [open]);

    const submitRef = useRef(undefined);

    const {data} = useQuery({
        queryFn: () => formBuilderService.listByModule(module),
        queryKey: ["template-list"],
    })

    const handleModule = (type, templateId = null) => {
        setMode(type)
        setTemplateId(templateId)
    }

    return (
        <Modal open={open} setOpen={setOpen} title={"Formulários"} isCloseClick={false}>
            <Modal.Body className={"p-4 !mt-0"}>
                {
                    mode === "fill" && <FormFill submitRef={submitRef} handleModule={handleModule} templateId={templateId} templates={data} externalId={externalId} object={object} setIsLoading={setIsLoading}/>
                }

                {
                    mode === "list" && <FormList handleModule={handleModule} templates={data} canCreateNewForms={canCreateNewForms}/>
                }

                {
                    mode === "submissions" && <FormSubmissions templateId={templateId} templates={data} externalId={externalId}/>
                }
            </Modal.Body>
            {
                mode !== "list" &&
                <Modal.Footer>
                    {
                        mode !== "list" &&
                        <Button target={"secondary"} onClick={() => handleModule("list")}>
                            Voltar
                        </Button>
                    }
                    {
                        mode === "fill" &&
                        <Button
                            onClick={() => submitRef?.current.submit()}
                            actionFeedbackType='save'
                            deferActionFeedback
                            loadingText="Salvando..."
                            successText="Salvo com sucesso"
                        >

                            Salvar
                        </Button>
                    }
                </Modal.Footer>
            }
        </Modal>
    );
};

export default FormBuilderModal;